export default "__VITE_ASSET__D0_AFdlc__"